/*
 * サブシステム名：マスタ管理
 * 機能名：発着地単価登録 package版
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'

import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'

const DdCheckbox = () => import('../../components/DdCheckbox.vue')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstHacchakuchiTankaEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdNumericBox,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    id: 0,
    rec: {},
    invalidMessages: {},

    // watch用
    isLoading: false,

    // ヘッダーリスト
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersHacchakuchiList: header.mstHacchakuchiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,

    modeOfEdit: 2,
    modeKengen: 2
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      kihonJohoList: 'DDMasters/mstKihonJoho',
      currentKaishaCode: 'users/currentKaishaCode',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 単価表区分リスト
    filteredTankahyoKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN026')
    },
    // 単価表詳細区分リスト
    filteredTankahyoDetailKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN027')
    },
    // 取引先リスト
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 営業所リスト
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    // 品名リスト
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        // 取引先コードがNULL(空)、または選択中の取引先が対象
        return (elem.torihikisakiCd === null || elem.torihikisakiCd === '' || self.rec.torihikisakiCd === elem.torihikisakiCd) && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    // 運賃車種種別リスト
    filteredUnchinShashuShubetsu () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 荷姿種別リスト
    filteredNisugataSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT019')
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    // 発着地リスト
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hacchakuchiCd > elem2.hacchakuchiCd) { return 1 }
        if (elem1.hacchakuchiCd === elem2.hacchakuchiCd) { return 0 }
        return -1
      })
    },
    isRirekiFukusyaDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        console.log('★true')
        return true
      }
      console.log('★false')
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    }

  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      console.log('fetchData')
      return new Promise((resolve) => {
        console.log(this.id)
        this.HttpClient
          .get(`/api/v1/MstHacchakuchiTanka/find?id=${self.id}`)
          .then((data) => {
            if (data.payload) {
              console.log('★fetchData', data.payload)

              self.isLoading = true

              self.rec = data.payload
              delete self.rec.tekiyoStartYmd
              delete self.rec.tekiyoEndYmd
              // 単価表種類区分
              if (!self.rec.tankahyoKbn) {
                self.rec.tankahyoKbn = ''
              }
              // 単価表種類詳細区分
              if (!self.rec.tankahyoDetailKbn) {
                self.rec.tankahyoDetailKbn = ''
              }
              // 運賃車種種別
              if (!self.rec.unchinShashuSbt) {
                self.rec.unchinShashuSbt = ''
              }

              self.rec.tekiyoStartYmdString = self.rec.tekiyoStartYmdString ? self.rec.tekiyoStartYmdString : ''
              self.rec.tekiyoEndYmdString = self.rec.tekiyoEndYmdString ? self.rec.tekiyoEndYmdString : ''

              this.$nextTick(() => { self.isLoading = false })
            }
            resolve()
          })
      })
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho', 'mstshubetsu', 'msyskubun', 'msthacchakuchi', 'msthinmei', 'mstkihonjoho'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.rec = {
              tankahyoCd: null,
              tankahyoKbn: null,
              tankahyoDetailKbn: null,
              torihikisakiCd: null,
              eigyoshoCd: !self.eigyoshoLockFlg ? self.userEigyoshoCd : '',
              hatsuchiCd: null,
              chakuchiCd: null,
              kyoriFrom: null,
              kyoriTo: null,
              suryoFrom: null,
              suryoTo: null,
              juryoFrom: null,
              juryoTo: null,
              sharyoSizeFrom: null,
              sharyoSizeTo: null,
              hinmeiCd: null,
              unchinShashuSbt: null,
              tanka: null,
              hiwayPrice: null,
              userKingakuKazei1: null,
              userKingakuKazei2: null,
              userKingakuKazei3: null,
              userKingakuKazei4: null,
              userKingakuHikazei1: null,
              userKingakuHikazei2: null,
              tekiyoStartYmdString: '2000/01/01',
              tekiyoEndYmdString: '2100/01/01',
              hyojiOrder: 9999,
              autoIssueNoMode: false
            }
            console.log('★Initialize', self.rec)
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★savedInputRestorePromise', c)
            resolve()
          })
        },
        existsIdMethod: () => {
          return this.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }
            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, opt)
      this.initializeForRegister(opt)
    },
    onRirekiFukushaButtonClick: function (e) {
      console.log('onRirekiFukushaButtonClick', e)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data().rec
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/MstHacchakuchiTanka/Delete?id=${self.id}&tm=${self.rec.timestamp}`, self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.modeOfEdit = 0
          self.rec.autoIssueNoMode = true
          self.rec.tankahyoCd = null
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      console.log('★保存ボタンクリック')
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            console.log('★registerResponsePromise', self.id)
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.rec.tankahyoCd !== this.rec.tankahyoCd
        },
        getIdMethod: () => {
          console.log('getIdMethod', self.id)
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            console.log('continuousInputInitializePromise', id)
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          console.log('getTransitionBackParams', self.id)
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          console.log('isUpdateModeMethod', self.id)
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          console.log('★getSavedInputMethod★')
          return {}
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f

      if (this.id === 0) {
        console.log('★登録処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.post('/api/v1/MstHacchakuchiTanka/Create', this.rec)
      } else {
        console.log('★更新処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.put(`/api/v1/MstHacchakuchiTanka/Update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      console.log('★validate start', this.cloneData)
      console.log('◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆', this.$refs)
      const msg = validators.compareDate(this.rec.tekiyoStartYmdString, this.rec.tekiyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      console.log('★validate OK')
      return true
    },
    deleteValidate: function () {
      console.log('delete=cloneData', this.cloneData)
      if (this.rec.tankahyoCd !== this.cloneData.rec.tankahyoCd) {
        this.$refs.tankahyoCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['単価表コード']))
        this.setInvalidSummaryMessage('COME0015')
        return false
      }
      console.log('validate OK')
      return true
    },
    changeAutoIssueMode: function () {
      if (!this.rec.autoIssueNoMode) { return }
      this.clearInvalidMessage(this.$refs)
      this.rec.tankahyoCd = null
    }
  }
}
